import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { CHAPTERS } from "../lib/data";

/**
 * QR Pasture Experience — the single landing page every printed QR code
 * points to. Welcomes the scanner, then hands them straight to the chapters
 * so they can find where they belong in the storybook.
 */
export default function QRLanding() {
  return (
    <div
      className="parchment min-h-screen pt-20 pb-16 px-6 relative overflow-hidden"
      data-testid="qr-landing-page"
    >
      <SEO
        title="Welcome to the Pasture"
        description="You've scanned a Salty Moo™ code. Pull up a rocking chair — the pasture is waiting."
        path="/qr"
      />

      <div className="max-w-2xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.4em] text-[#D62839] mb-3">
          You&rsquo;ve arrived at the pasture
        </p>
        <h1 className="font-display text-5xl md:text-6xl text-[#4B3A2F] leading-tight mb-3">
          Well hi there, friend.
        </h1>
        <p className="font-script text-3xl md:text-4xl text-[#4B3A2F] mb-6">
          you found us.
        </p>
        <div className="gold-rule mx-auto w-24 mb-8" />

        <p className="font-body text-lg text-[#2C2724]/90 leading-relaxed mb-10">
          You just scanned a little Salty Moo<sup>™</sup> code — thank you for
          following the trail. Pick a chapter below and step into the pasture.
          Or, if you&rsquo;d rather begin at the very first page, the barn
          doors are right this way.
        </p>

        {/* Big CTA to Welcome */}
        <Link
          to="/"
          data-testid="qr-start-btn"
          className="btn-pasture inline-flex items-center justify-center mb-14"
        >
          Start at the barn doors
        </Link>

        <p className="text-xs uppercase tracking-[0.4em] text-[#4B3A2F] mb-5">
          Or hop straight to a chapter
        </p>

        <ul
          data-testid="qr-chapters-list"
          className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left"
        >
          {CHAPTERS.filter((c) => c.path !== "/").map((c) => (
            <li key={c.path}>
              <Link
                to={c.path}
                data-testid={`qr-chapter-link-${c.short}`}
                className="flex items-baseline gap-4 px-4 py-3 rounded-md bg-[#F9F6F0] border border-[#E7DFD5] hover:border-[#A87149] hover:bg-[#F3EBDD] transition-colors"
              >
                <span className="font-display italic text-[#D62839] w-8">
                  {c.short}
                </span>
                <span className="font-display text-xl text-[#4B3A2F]">
                  {c.label}
                </span>
              </Link>
            </li>
          ))}
        </ul>

        <p className="font-script text-2xl text-[#4B3A2F] mt-14">
          Where Faith Finds Its Salt.
        </p>
      </div>
    </div>
  );
}
